export default __webpack_public_path__ + "static/media/ash.d36b89a9.png";